import i18nRouteMeta from '@/app-core/mixins/i18n/i18nRouteMeta'
import {HmacMD5} from '@/app-core/lib/crypto/crypto'
import API from '@/app-core/api/Api'
import BrandSlider from '@/app-theme/views/home/BrandSlider.vue'
import AutoUpdateApiData from '@/app-core/mixins/api/autoUpdateApiData'
import OrderStatusEnum from '@/app-core/api/enums/OrderStatusEnum'
import {toLocaleUpperCase} from '@/app-core/lib/helpers'
import StoreCommon from '@/app-core/mixins/store/storeCommon'
import OrderTypeEnum from '@/app-core/api/enums/OrderTypeEnum'
import OrderCommon from '@/app-core/mixins/order/orderCommon'

export default {
  name      : 'CheckoutSuccess',
  components: {BrandSlider},
  directives: {},
  mixins    : [i18nRouteMeta, AutoUpdateApiData, StoreCommon, OrderCommon],
  props     : {
    orderId: {
      type   : [Number, String],
      default: undefined
    }
  },
  enums    : {OrderStatusEnum, OrderTypeEnum},
  dataStore: {
    AppCart  : 'App.Cart',
    AppStores: 'App.Stores'
  },
  data() {
    return {
      autoUpdateApiDataOptions: {
        timeout  : 5000, // 10 * 60 * 1000,
        autoStart: false
      },
      isLoading  : true,
      showData   : false,
      orderFound : false,
      orders     : [],
      orderCode  : '',
      isScheduled: false,
      scheduled  : '',
      orderType  : OrderTypeEnum.COLLECTION,
      rating     : {
        userRating : 0,
        userComment: '',
        appRating  : 0,
        appReviews : 0,
        appRated   : false,
        loading    : false,
        loaded     : false
      }
    }
  },
  computed: {
    allOrdersCompleted() {
      return this.ordersCompleted(this.orders, 'StatusId')
    },

    orderCodeString() {
      const [oldCode, newCode] = this.orderCode?.split('-')
      const code = (newCode || oldCode || '')
      const part1 = code.slice(0, 3)
      const part2 = code.slice(3, 6)
      return `#${part1}-${part2}`
    }
  },
  watch: {
    allOrdersCompleted(newVal) {
      if (newVal) {
        this.stopAutoUpdateApiData()
      } else {
        this.startAutoUpdateApiData(this.getData)
      }
    },

    orderFound(newVal) {
      if (newVal) this.getAppRating()
    }
  },
  beforeCreate() {
  },
  created() {
    const storageKey = HmacMD5.hash('ORDERID')
    this.$sessionStorage.remove(storageKey)

    if (this.orderId && this.orderId !== '0') {
      this.getData()
    } else {
      this.showData = true
    }
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    toLocaleUpperCase,

    getData() {
      if (!this.orderId || this.orderId === '0') return

      this.isLoading = true

      const payload = {
        OrderId         : this.orderId,
        PaymentOrderCode: this.$route.params.paymentOrderCode || '',
        PaymentEventId  : this.$route.params.paymentEventId || ''
      }

      API.Resource.Checkout.Success(payload)
        .then(response => {
          if (API.isResponseSuccess(response)) {
            this.orderFound = true
            const data = API.responseData(response)
            this.orders = data.Stores
            this.orderCode = data.Code
            this.isScheduled = data.IsScheduled
            this.scheduled = data.Scheduled
            this.orderType = data.OrderType || OrderTypeEnum.COLLECTION
          } else {
            this.stopAutoUpdateApiData()
          }
        })
        .catch(e => {
          this.stopAutoUpdateApiData()
        })
        .finally(() => {
          this.isLoading = false
          this.showData = true
        })
    },

    getAppRating() {
      if (!this.orderId) return

      const payload = {
        OrderId: this.orderId
      }

      API.Resource.Rating.Get(payload)
        .then(response => {
          if (API.isResponseSuccess(response)) {
            const data = API.responseData(response)
            this.rating.appRating = data.Rate
            this.rating.appReviews = data.Count
            this.rating.appRated = data.Rated
            this.rating.loaded = true
          }
        })
        .catch(e => {
        })
        .finally(() => {
        })
    },

    rateTheApp() {
      if (!this.orderId) return

      this.isLoading = true

      const payload = {
        OrderId: this.orderId,
        Rate   : this.rating.userRating,
        Comment: this.rating.userComment
      }

      API.Resource.Rating.Rate(payload)
        .then(response => {
          if (API.isResponseSuccess(response)) {
            this.rating.userRating = 0
            this.rating.userComment = ''
            this.rating.loading = false

            this.getAppRating()
          }
        })
        .catch(e => {
        })
        .finally(() => {
          this.rating.loading = false
        })
    },

    getOrderStatusById(statusId) {
      const statuses = this.$te('Cart.OrderStatus') ? this.$t('Cart.OrderStatus') : []

      return statuses.find(status => status.Id === statusId)
    },

    getOrderStatusNameById(statusId) {
      return this.getOrderStatusById(statusId)?.Name || ''
    },

    getOrderStatusColorById(statusId) {
      return this.getOrderStatusById(statusId)?.Color || ''
    }
  }
}
